import refinementsFromUrl from '../routes/searchResult/model/refinementsFromUrl';
import { ForLease, ForSale } from './model/constants/channels';
import type { RefinementsType } from './model/constants/filterTypes';

export const canSetAlert = (url = ''): boolean => {
  const refinements = refinementsFromUrl(url);
  const { mapView, channelObject, localities }: RefinementsType = refinements;

  if (mapView) return false;

  const unsupportedChannel = ![ForSale.id, ForLease.id].includes(channelObject.id);

  if (unsupportedChannel) return false;

  const unsupportedSearch = localities === undefined;

  if (unsupportedSearch) return false;

  return true;
};
